import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';

@Component({
  selector: 'app-payment-mode-field',
  templateUrl: './payment-mode-field.component.html',
  styleUrls: ['./payment-mode-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PaymentModeFieldComponent implements OnInit{
  @Input('required') isRequired = false;
  @Input('multiple') isMultiSelect:boolean = true;

  form: FormGroup;
  constructor(private ctrlContainer: FormGroupDirective){};

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    if (this.isRequired) {
      this.form.addControl('payment_mode', new FormControl([], Validators.required));
    } else {
      this.form.addControl('payment_mode', new FormControl([]));
    }

    this.form.controls['payment_mode'].valueChanges.subscribe((val: any) => {
      if (val == null) {
        this.form.controls['payment_mode'].setValue([]);
      }
    });
  }
  selectionChange(event:any){
    if(!this.isMultiSelect && event.isUserInput && event.source.selected){
      this.form.controls['payment_mode'].setValue([event.source.value]);
    }
  }

  selectAll() {
    this.form.controls['payment_mode'].setValue(['online', 'offline']);
  }

  unSelectAll() {
    this.form.controls['payment_mode'].setValue([]);
  }

  ngOnDestroy(): void {
    this.form.removeControl('payment_mode');
  }
}
